import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Hexagon from '../../../../../../common/chart/hexagon'
import { isInValidValue, valToPercent } from '../../../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../../../utils/common'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../../helper'
import {
  selectDataViewByTrend,
  selectIndicatorById,
  selectYears,
} from '../store/slice'
import Chart from './Chart'

const idRoa = 'RT2003'

const idRoe = 'RT2004'

const Trend = ({ isDynamicReport, id, check = [] }) => {
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const locale = useSelector((state) => state.i18n.locale)
  const years = useSelector(selectYears)

  const tYear = years[years.length - 1] || EMPTY_VALUE

  const dataTYear = dataByTrend.find((item) => item.year === +tYear) || {}

  const chartParamRoa = {
    line: {
      color: '#006AA6',
      ...getValueAndTitleCheckbox(indicatorById, 'RT2003'),
    },
    area: {
      color: '#BED7E3',
      dotColor: '#97C3D8',
      ...getValueAndTitleCheckbox(indicatorById, 'RTG2003'),
    },
  }

  const chartParamRoe = {
    line: {
      color: '#F49966',
      ...getValueAndTitleCheckbox(indicatorById, 'RT2004'),
    },
    area: {
      color: '#FFE7D0',
      dotColor: '#F2CBA4',
      ...getValueAndTitleCheckbox(indicatorById, 'RTG2004'),
    },
  }

  const dataConvert = dataByTrend.map((item) => {
    const newItem = { ...item }

    Object.keys(item).forEach((key) => {
      if (key !== 'year') {
        newItem[key] = !isInValidValue(item[key]) ? item[key] * 100 : undefined
      }
    })

    return newItem
  })

  const isNoData = !dataByTrend.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  const isHasRoa = !isDynamicReport || check.includes('RT2003')
  const isHasRoe = !isDynamicReport || check.includes('RT2004')
  const isH100 = isHasRoa && isHasRoe

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicReport,
          isNoData,
          isH100 ? 332 : 332 / 2,
        ),
      }}
      className="dFlex"
    >
      {!dataByTrend.length ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <>
          <div className="h100 w30">
            {isHasRoa && (
              <div className={isH100 ? 'pb1 h50' : 'h100'}>
                <Hexagon
                  color="#006AA6"
                  title={`ROA ${tYear}`}
                  value={valToPercent(dataTYear[idRoa], locale)}
                />
              </div>
            )}
            {isHasRoe && (
              <div className={isH100 ? 'pt1 h50' : 'h100'}>
                <Hexagon
                  color="#F49966"
                  title={`ROE ${tYear}`}
                  value={valToPercent(dataTYear[idRoe], locale)}
                />
              </div>
            )}
          </div>
          <div className="h100 w70">
            {isHasRoa && (
              <div className={isH100 ? 'h50 pb1 dFlex' : 'h100 dFlex'}>
                <Chart
                  data={dataConvert}
                  chartParam={chartParamRoa}
                  isDynamicReport={isDynamicReport}
                />
              </div>
            )}
            {isHasRoe && (
              <div className={isH100 ? 'h50 pt1 dFlex' : 'h100 dFlex'}>
                <Chart
                  data={dataConvert}
                  chartParam={chartParamRoe}
                  isDynamicReport={isDynamicReport}
                />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default Trend
